import {NgModule, ErrorHandler, ElementRef} from '@angular/core';
import {IonicApp, IonicModule, IonicErrorHandler, DeepLinkConfig} from 'ionic-angular';
import {MyApp} from './app.component';
import {TabsPage} from '../pages/tabs/tabs';
import {LoginPage} from "../pages/login/login";
import {UserService} from "../services/user.services";
import {AppConfigService} from "../services/appConfig.service";
import {ServicePage} from '../pages/service/service';
import {HomePage} from "../pages/home/home";
import {LotteryService} from "../services/lottery.services";
import {UserPage} from "../pages/user/user";
import {SysMsgViewPage} from "../pages/personMsgView/sysMsgView";
import { PaymentCodeViewPage } from '../pages/paymentCode/paymentCodeView';
import {LotteryTabsPage} from "../pages/lotteryTabPanel/lotteryTabPanel";
import {LotteryPage} from "../pages/lottery/lottery";
import {OpenNumComponent} from "../component/openNum/openNum";
import {HelperPage} from "../component/helper/helper";
import {DropSelectPanel} from "../component/dropSelectPanel/dropSelectPanel";
import {UserEditPage} from '../pages/userEdit/userEdit';
import {TextSelectComponent} from "../component/+lotteryMath/textSelect";
import {RecordListPage} from "../pages/recordList/recordList";
import {PersonMsgPage} from '../pages/personMsg/personMsg';
import {GameRecordSearchPage} from '../pages/gameRecordSearch/gameRecordSearch';
import {BalanceChangeSearchPage} from '../pages/balanceChangeSearch/balanceChangeSearch';
import {SysMsgListPage} from '../pages/sysMsgList/sysMsgList';
import {AgentPEPage} from "../pages/agentPE/agentPE";
import {RegisterPage} from "../pages/register/register";
import {AgencyMemberSearchPage} from "../pages/agencyMemberSearch/agencyMemberSearch";
import {AgentAutoRegPage} from "../pages/agentAutoReg/agentAutoReg";
import {AgencyUserTBalancePage} from "../pages/agencyUserTBalance/agencyUserTBalance";
import {ReportWinLossSearchPage} from "../pages/reportWinLossSearch/reportWinLossSearch";
import {ReportDTSearchPage} from "../pages/reportDTSearch/reportDTSearch";
// import {ReportWinLoss2SearchPage} from "../pages/reportWinLoss2Search/reportWinLoss2Search.ts";
// import {ReportDTDetailsPage} from "../pages/reportDTDetails/reportDTDetails.ts";
import {SelectMarkNum} from "../component/selectMarkNum/selectMarkNum";
import {SixMark49NumbersComponent} from "../component/sixmark/49Numbers/sixMark49Numbers";
import {SixMarkAnimalsComponent} from "../component/sixmark/animals/sixMarkAnimals";
import {SixMarkThreePartsComponent} from "../component/sixmark/threeParts/sixmarkThreeParts";
import {SixMarkSpecial49NumbersComponent} from "../component/sixmark/special49Numbers/sixmarkSpecial49Numbers";
import {SixMarkBigSmallComponent} from "../component/sixmark/bigSmall/sixmarkBigSmall";
import {SixMarkPopup} from "../component/sixMarkPopup/sixMarkPopup";
import {SixMarkDropDownPanelComponent} from "../component/sixMarkDropDownPanel/sixMarkDropDownPanel";
import {TranslateLoader, TranslateModule, TranslateStaticLoader} from 'ng2-translate';

import {
    LotteryMathZH1Component,
    LotteryMathZH2Component,
    LotteryMathZXZHComponent,
    LotteryMathDSComponent,
    LotteryMathDWDComponent,
    LotteryMathHZComponent,
    LotteryMathDXTXComponent,
    LotteryMathBDComponent,
    LotteryMathRZXComponent,
    LotteryMathLTZXHComponent,
    LotteryMathDTComponent,
    LotteryMathZXFSComponent,
    LotteryMathSMComponent
} from "../component/+lotteryMath";
import {LotteryRecordPage} from "../pages/lotteryRecord/lotteryRecord";
import {AgencyManagePage} from "../pages/agencyManage/agencyManage";
import {LotteryHistoryPage} from "../pages/lotteryHistory/lotteryHistory";
import {RechargePage} from "../pages/recharge/recharge";
import {RechargeWebsitePage} from "../pages/service/rechargeWebsite";
import {WithDrawalPage} from "../pages/withDrawal/withDrawal";
import {PersonBankCardPage} from "../pages/personBankCard/personBankCard";
import {GoPeriodsPage} from "../pages/goPeriods/goPeriods";
import {GoPeriodsMMCPage} from "../pages/goPeriodsMMC/goPeriodsMMC";
import {BetDetailsPage} from "../pages/betDetails/betDetails";
import { BetDetailsTracePage } from "../pages/betDetailsTrace/betDetailsTrace";
import {ReportWinLoss2ListPage} from "../pages/reportWinLoss2List/reportWinLoss2List";
import {AgentPEListPage} from "../pages/agentPEList/agentPEList";
import {ReportWinLossListPage} from "../pages/reportWinLossList/reportWinLossList";
import {ReportWinLossDetailsPage} from "../pages/reportWinLossDetails/reportWinLossDetails";
import {AgencyUserListPage} from "../pages/agencyUserList/agencyUserList";
import {UserBetListPage} from "../pages/userBetList/userBetList";
import {TraceListPage} from "../pages/traceList/traceList";
import {BalanceChangeListPage} from "../pages/balanceChangeList/balanceChangeList";
import {AgentAutoRegNewPage} from "../pages/agentAutoRegNew/agentAutoRegNew";
import {AgencyUserRebatePage} from "../pages/agencyUserRebate/agencyUserRebate";
import {AgentUserQuotaPage} from "../pages/agentUserQuota/agentUserQuota";
import {AgencyUserBetSearchPage} from "../pages/agencyUserBetSearch/agencyUserBetSearch";
import {AgencyUserZbSearchPage} from "../pages/agencyUserZbSearch/agencyUserZbSearch";
import {AgencyUserZbListPage} from "../pages/agencyUserZbList/agencyUserZbList";
import {AgencyUserBetListPage} from "../pages/agencyUserBetList/agencyUserBetList";
import {DepositListPage} from "../pages/depositList/depositList";
import {WithdrawListPage} from "../pages/withdrawList/withdrawList";
import {AgencyUserDepositPage} from "../pages/agencyUserDeposit/agencyUserDeposit";
import {AgentAutoRegEditPage} from "../pages/agentAutoRegEdit/agentAutoRegEdit";
import {PersonBankCardConfirmPage} from "../pages/personBankCardConfirm/personBankCardConfirm";
import {PersonBankCardAddPage} from "../pages/personBankCardAdd/personBankCardAdd";
import {PersonMsgViewPage} from "../pages/personMsgView/personMsgView";
import {ImproveUserPage, ModalContentPolicyPage} from "../pages/improveUser/improveUser";
import {SixMarkService} from "../services/sixmark.services";
import {SixMarkBaseComponent} from "../component/sixmark/sixMarkBase";
import {SpeedTestPage} from "../pages/speedTest/speedTest";
// import {DecimalPipe, CommonModule} from "@angular/common";

// David Custom
import { CommonService } from "../services/common.service";
import { OpenResultTbl } from "../component/openResultTbl/openResultTbl";
import { SelectNumFastComponent } from "../component/+lotteryMath/selectNumFast/selectNumFast";
import {UserTest} from "../pages/userTest/userTest";
import { HeaderSwitchAccount } from "../pages/headerSwitchAccount/headerSwitchAccount";
import { FeedbackPage } from "../pages/feedback/feedback";
import {FundTransferPage} from "../pages/fundTransfer/fundTransfer";
import {IbcServices} from "../services/ibc.services";
import {WithdrawDetailPage} from "../pages/withdrawDetail/withdrawDetail";
import {DepositDetailPage} from "../pages/depositDetail/depositDetail";

import { TaiXiuPage } from "../pages/TaiXiu/TaiXiuPage";
import { XocDiaPage } from "../pages/XocDia/XocDiaPage";
import {SelectChipComponent} from "../component/gameTaiXiu/selectChip/selectChip";
import { TaixiuServices } from "../services/taixiu.services";
import {DiceJumpComponent} from "../component/gameTaiXiu/diceJump/diceJump";
import {ThirdpartyGame} from "../pages/thirdpartyGame/thirdpartyGame";
import {HabaGames} from "../pages/habaGames/habaGames";
import {HabaServices} from "../services/haba.services";
import {HabaGamesPlay} from "../pages/habaGamesPlay/habaGamesPlay";
import {HabaHelpLink} from "../pages/habaHelpLink/habaHelpLink";
import {PromoMsgPage} from "../pages/promoMsg/promoMsg";
import {LivecasinoPage} from "../pages/livecasino/livecasino";
import {EbetService} from "../services/ebet.service";
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {XocdiaService} from "../services/xocdia.service";
import {BancaServices} from "../services/banca.services";
import {BauCua1GiayPage} from "../pages/baucua1giay/baucua1giaypage";
import {OanTuTiPage} from "../pages/oantuti/oantutipage";
import {BauCua1PhutPage} from "../pages/baucua1phut/baucua1phutpage";
import {BauCuaService} from "../services/baucua.service";
import {OantutiService} from "../services/oantuti.services";
import {BauCuaHistoryPage} from "../pages/baucuaHistory/baucuaHistory";
import {BetDetailsBauCuaPage} from "../pages/betDetailsBauCua/betDetailsBauCua";
import {RechargeZaloPayPage} from "../pages/rechargeZaloPay/rechargeZaloPay";

import { ThirdpartyGamesServices } from '../services/thirdGame.services';
import { ChunkPipe } from '../component/chunk/chunk.pipe'; 
import { ReportWinLoss2SearchPage } from '../pages/reportWinLoss2Search/reportWinLoss2Search';
import { ReportDTDetailsPage } from '../pages/reportDTDetails/reportDTDetails';
import { ChildCardComponent } from '../component/card/child-card.component';
import { ChonSoComponent } from '../component/chonso/chonso.component';
import { TypeFastNumber } from '../component/TypeFastNumber/type-fast-number';
import { SelectTypeDeTopBotComponent } from '../component/+lotteryMath/selectTypeDeTopBot/selectTypeDeTopBot';
import { Http } from '@angular/http';

@NgModule({
    declarations: [
        MyApp,
        TabsPage,
        LoginPage,
        ServicePage,
        HomePage,
        UserPage,
        SysMsgViewPage,
        PaymentCodeViewPage,
        OpenNumComponent,
        OpenResultTbl,
        HelperPage,
        DropSelectPanel,
        TextSelectComponent,
        RechargePage,
        WithDrawalPage,
        UserEditPage,
        PersonMsgPage,
        GameRecordSearchPage,
        BalanceChangeSearchPage,
        SysMsgListPage,
        AgentPEPage,
        RegisterPage,
        AgencyMemberSearchPage,
        AgentAutoRegPage,
        AgencyUserTBalancePage,
        ReportDTSearchPage,
        ReportWinLoss2SearchPage,
        RecordListPage,
        SelectMarkNum,
        SixMark49NumbersComponent,
        SixMarkAnimalsComponent,
        SixMarkThreePartsComponent,
        SixMarkSpecial49NumbersComponent,
        SixMarkBigSmallComponent,
        SixMarkPopup,
        SixMarkDropDownPanelComponent,
        SixMarkBaseComponent,
        ModalContentPolicyPage,
        ChildCardComponent,
        /* Lottery Math Components */

        LotteryMathZH1Component,
        LotteryMathZH2Component,
        LotteryMathZXZHComponent,
        LotteryMathDSComponent,
        LotteryMathDWDComponent,
        LotteryMathHZComponent,
        LotteryMathDXTXComponent,
        LotteryMathBDComponent,
        LotteryMathRZXComponent,
        LotteryMathLTZXHComponent,
        LotteryMathDTComponent,
        LotteryMathZXFSComponent,
        LotteryMathSMComponent,

        ReportWinLossSearchPage,
        ReportWinLoss2SearchPage,
        ReportWinLoss2ListPage,
        AgentPEListPage,
        ReportWinLossListPage,
        ReportWinLossDetailsPage,
        AgencyUserListPage,
        AgencyUserRebatePage,
        AgentUserQuotaPage,
        AgencyUserBetSearchPage,
        AgencyUserZbSearchPage,
        AgencyUserZbListPage,
        AgencyUserBetListPage,


        LotteryPage,
        LotteryTabsPage,
        LotteryRecordPage,
        AgencyManagePage,
        LotteryHistoryPage,
        RechargePage,
        RechargeWebsitePage,
        RechargeZaloPayPage,
        PersonBankCardPage,
        WithDrawalPage,
        GoPeriodsPage,
        GoPeriodsMMCPage,
        BetDetailsPage,
        BetDetailsTracePage,
        ReportDTDetailsPage,
        UserBetListPage,
        TraceListPage,
        BalanceChangeListPage,
        AgentAutoRegNewPage,
        DepositListPage,
        WithdrawListPage,
        AgencyUserDepositPage,
        AgentAutoRegEditPage,
        PersonBankCardConfirmPage,
        PersonBankCardAddPage,
        PersonMsgViewPage,
        ImproveUserPage,
        SpeedTestPage,

        SelectNumFastComponent,
        SelectTypeDeTopBotComponent,
        UserTest,
        HeaderSwitchAccount,
        FeedbackPage,
        FundTransferPage,
        WithdrawDetailPage,
        DepositDetailPage,

        TaiXiuPage,
        XocDiaPage,
        BauCua1GiayPage,
        OanTuTiPage,
        BauCua1PhutPage,
        SelectChipComponent,
        DiceJumpComponent,
        ThirdpartyGame,
        HabaGames,
        HabaGamesPlay,
        HabaHelpLink,
        PromoMsgPage,
        LivecasinoPage,
        BauCuaHistoryPage,
        BetDetailsBauCuaPage,
        ChunkPipe,
        ChonSoComponent,
        TypeFastNumber
    ],
    imports: [
        TranslateModule.forRoot(
            {
                provide: TranslateLoader,
                useFactory: (http: Http) => new TranslateStaticLoader(http, 'build/assets/i18n', '.json'),
                deps: [Http]
            }
        ),
        IonicModule.forRoot(MyApp, {
                mode: 'ios',
                backButtonIcon: 'arrow-back',
                iconMode: 'ios',
                pageTransition: 'ios',
                tabsPlacement: 'bottom',
                backButtonText: ''
            }, {
                // links: [
                //     { component: LotteryRecordPage, name: ' lottery', segment: 'lottery-record' }
                //   ]
            }
        )],
    bootstrap: [IonicApp],
    entryComponents: [
        LoginPage,
        MyApp,
        TabsPage,
        ServicePage,
        HomePage,
        UserPage,
        SysMsgViewPage,
        PaymentCodeViewPage,
        LotteryPage,
        LotteryTabsPage,
        RecordListPage,
        LotteryRecordPage,
        AgencyManagePage,
        AgentPEPage,
        LotteryHistoryPage,
        RechargeWebsitePage,
        RechargeZaloPayPage,
        PersonBankCardPage,
        RechargePage,
        WithDrawalPage,
        PersonBankCardPage,
        UserEditPage,
        PersonMsgPage,
        GameRecordSearchPage,
        BalanceChangeSearchPage,
        SysMsgListPage,
        GoPeriodsPage,
        GoPeriodsMMCPage,
        BetDetailsPage,
        BetDetailsTracePage,
        RegisterPage,
        AgencyMemberSearchPage,
        AgentAutoRegPage,
        AgencyUserTBalancePage,
        ReportDTSearchPage,
        ReportWinLossSearchPage,
        ReportWinLoss2SearchPage,
        ReportWinLoss2ListPage,
        ReportDTDetailsPage,
        AgentPEListPage,
        ReportWinLossListPage,
        ReportWinLossDetailsPage,
        AgencyUserListPage,
        UserBetListPage,
        TraceListPage,
        BalanceChangeListPage,
        AgentAutoRegNewPage,
        AgencyUserRebatePage,
        AgentUserQuotaPage,
        AgencyUserBetSearchPage,
        AgencyUserZbSearchPage,
        AgencyUserZbListPage,
        AgencyUserBetListPage,
        DepositListPage,
        WithdrawListPage,
        AgencyUserDepositPage,
        AgentAutoRegEditPage,
        PersonBankCardConfirmPage,
        PersonBankCardAddPage,
        PersonMsgViewPage,
        ImproveUserPage,
        ModalContentPolicyPage,
        SpeedTestPage,
        UserTest,
        HeaderSwitchAccount,
        FeedbackPage,
        FundTransferPage,
        WithdrawDetailPage,
        DepositDetailPage,

        TaiXiuPage,
        XocDiaPage,
        BauCua1GiayPage,
        OanTuTiPage,
        BauCua1PhutPage,
        ThirdpartyGame,
        HabaGames,
        HabaGamesPlay,
        HabaHelpLink,
        PromoMsgPage,
        LivecasinoPage,
        BauCuaHistoryPage,
        BetDetailsBauCuaPage,
    ],
    providers: [
        UserService,
        IbcServices,
        AppConfigService,
        LotteryService,
        SixMarkService,
        CommonService,
        TaixiuServices,
        HabaServices,
        BancaServices,
        EbetService,
        ScreenOrientation,
        XocdiaService,
        BauCuaService,
        OantutiService,
        InAppBrowser,
        ThirdpartyGamesServices,
        {
            provide: ErrorHandler,
            useClass: IonicErrorHandler
        }
    ],
    exports:[
        ChonSoComponent,
        TypeFastNumber
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts